// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'antd/dist/reset.css'; // Import Ant Design's reset styles
import './index.css'; // Import global styles
import './responsive.css'; // Import responsive styles
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; 
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// serviceWorkerRegistration.register(); // Registration is now handled in AppUpdateNotification.js
reportWebVitals();